import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import {
    ConditionSetting,
    ConditionTableColumn,
    DateTableColumn,
    TableColumn,
} from '../../components/kiene-table/table-column';
import { TableDescriptor, ToolbarButton } from '../../components/kiene-table/table-descriptor';
import { Condition, Operator, TableOption } from '../../components/kiene-table/table-option';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { ChangeCurrentClientService } from '../../administration/client/change-current-client/change-current-client.service';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogInput } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { HeimtierBeleg } from '../heimtier-beleg';

@Component({
    selector: 'kiene-heimtier-belege-table',
    templateUrl: './heimtier-belege-table.component.html',
    styleUrls: ['./heimtier-belege-table.component.scss'],
})
// erzeugt mit KieneTableTemplateTS.ts.template
export class HeimtierBelegeTableComponent implements OnInit {
    tableDescriptor = new TableDescriptor();

    @Input() kunde_id: number;

    constructor(
        private readonly dialog: MatDialog,
        protected router: Router,
        private readonly tableService: KieneTableService,
        private readonly api: KieneBackendApiService,
        private readonly lss: LocalStorageService,
        private readonly changeCurrentClientService: ChangeCurrentClientService,
        private readonly messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        this.configureTableDescriptor();
    }

    getColumns(): TableColumn[] {
        const columns: TableColumn[] = [];

        columns.push(new TableColumn('ht_beleg_id', 'Beleg ID'));
        columns.push(new TableColumn('beleg_nr', 'BelegNr'));
        columns.push(new TableColumn('kunde', 'kunde'));
        columns.push(new TableColumn('tierarzt', 'Tierarzt'));
        columns.push(new DateTableColumn('datum', 'Datum', 'dd.MM.YYYY'));
        columns.push(new DateTableColumn('behandlung_seit', 'In Behandlung seit'));
        columns.push(
            new ConditionTableColumn(
                'rechnung_id',
                'Rechn.',
                [
                    new ConditionSetting([new Condition('rechnung_id', Operator.EXISTIERT, null)], {
                        icon: 'attach_money',
                    }),
                ],
                { sortFields: ['rechnung_id'] },
            ),
        );
        columns.push(new TableColumn('status', 'Status'));

        return columns;
    }

    getOptions(): TableOption[] {
        const options: TableOption[] = [];
        options.push(
            new TableOption(this.belegLoeschen.bind(this), 'Löschen', 'delete', 7034, {
                conditions: [new Condition('status_id', Operator.GLEICH, 221)],
            }),
        );
        return options;
    }

    createOrEditHeimtierBelege(input?: HeimtierBeleg) {
        if (!this.lss.getCurrentClient()) {
            this.changeCurrentClientService.openChangeDialog().subscribe({
                next: () => {
                    this.createNewHeimtierBelege();
                },
            });
        } else {
            this.createNewHeimtierBelege();
        }
    }

    openBeleg(beleg: HeimtierBeleg) {
        this.router.navigate(['heimtiere', 'belege', beleg?.ht_beleg_id]).then();
    }

    private belegLoeschen(beleg: HeimtierBeleg) {
        const input = new ConfirmDialogInput();
        input.headline = 'Beleg löschen?';
        input.text = 'Wollen Sie den Beleg wirklich löschen?';
        input.okButton = 'Löschen';
        input.cancelButton = 'Abbrechen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result?.confirmed) {
                        this.api.deleteEntity(this.apiBaseUrl + 'heimtier_beleg/delete.php', beleg).subscribe({
                            next: () => {
                                this.tableService.reload('heimtierbelege_table');
                            },
                            error: err => {
                                this.messageService.errorMessage('Fehler beim Löschen!', err);
                            },
                        });
                    }
                },
            });
    }

    private configureTableDescriptor(): void {
        this.tableDescriptor.headline = 'Heimtier Belege';
        this.tableDescriptor.initialSortDirection = 'desc';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'heimtier_beleg/';
        this.tableDescriptor.initialSortColumn = 'beleg_nr';
        this.tableDescriptor.nameOfIdField = 'ht_beleg_id';
        this.tableDescriptor.searchPlaceholder = 'Heimtier Belege durchsuchen';
        this.tableDescriptor.uniqueIdentifier = 'heimtierbelege';
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDownloads = false;
        this.tableDescriptor.sendCurrentClient = true;
        this.tableDescriptor.showDetailsVoid = this.openBeleg.bind(this);

        this.tableDescriptor.columns = this.getColumns();
        this.tableDescriptor.options = this.getOptions();
        this.tableDescriptor.toolbarButtons = this.getToolbarButtons();

        this.tableDescriptor.tooltips['add_button'] = 'Neuen Heimtier Beleg anlegen';

        this.tableDescriptor.permissionCreate = 7032;
        this.tableDescriptor.addVoid = this.createOrEditHeimtierBelege.bind(this);
    }

    private getToolbarButtons(): ToolbarButton[] {
        const toolbarButtons = [];
        return toolbarButtons;
    }

    private createNewHeimtierBelege() {
        const beleg = new HeimtierBeleg();
        beleg.kunde_id = this.lss.getCurrentClient().kunde_id;
        this.api.post(this.apiBaseUrl + 'heimtier_beleg/create.php', beleg).subscribe({
            next: response => {
                this.router.navigate(['heimtiere', 'belege', response.ht_beleg_id]).then();
            },
        });
    }
}
